import * as cnt from './constants';

const initialState = {
  dialogOpen: false,
  messageCreating: false,
  messageCreateError: false,
  lastCreatedMessage: null,
  singleRecipient: null,
  connections: [],
};

export function massmessaging(state = initialState, { type, payload }) {
  switch (type) {
    case cnt.OPENMODAL: {
      return Object.assign({}, state, { dialogOpen: true });
    }
    case cnt.CLOSEMODAL: {
      return Object.assign({}, initialState);
    }
    case `${cnt.SENDMESSAGE}_STARTED`: {
      return Object.assign({}, state, { messageCreating: true, messageCreateError: false, lastCreatedMessage: null, singleRecipient: null });
    }
    case `${cnt.SENDMESSAGE}_SUCCESS`: {
      const { bulkMessageId: lastCreatedMessage, singleRecipient } = payload;
      return Object.assign({}, state, { messageCreating: false, messageCreateError: false, lastCreatedMessage, singleRecipient });
    }
    case `${cnt.SENDMESSAGE}_ERROR`: {
      return Object.assign({}, state, { messageCreating: false, messageCreateError: true });
    }
    case `${cnt.GETPARTNERS}_SUCCESS`: {
      return Object.assign({}, state, { connections: payload });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/store/reducer.js